import { Flex, theme } from "antd";
import React from "react";

import { SolutionIcon } from "./SolutionIcon";

import { SOLUTIONS, SolutionSlug } from "~/Atom/SolutionIcon/types";

export const SolutionTag: React.FC<{ solutionSlug: SolutionSlug }> = ({
  solutionSlug,
}) => {
  const { token } = theme.useToken();

  return (
    <div
      style={{
        borderRadius: "0.25rem",
        border: `1px solid ${token.colorBorder}`,
        padding: "0.125rem 0.25rem",
        fontSize: "0.75rem",
        lineHeight: "1rem",
        fontWeight: 400,
      }}
    >
      <Flex gap="0.25rem" justify="left" align="center">
        <SolutionIcon
          solutionSlug={solutionSlug}
          style={{
            height: "0.75rem",
            width: "0.75rem",
          }}
        />
        <span style={{ top: "-1px", position: "relative" }}>
          {SOLUTIONS[solutionSlug]}
        </span>
      </Flex>
    </div>
  );
};
